/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';

export const openCameraAccessAlertPopUp = createAction('popUps/OPEN_CAMERA_ACCESS_ALERT');

export const openUploadProcessPopUp = createAction('popUps/OPEN_UPLOAD_PROCESS');

export const openScanProcessPopUp = createAction('popUps/OPEN_SCAN_PROCESS');

export const openErrorPopUp = createAction('popUps/ERROR');

export const closePopUp = createAction('popUps/CLOSE_POP_UP');
